import { render } from "./NewsBanner.vue?vue&type=template&id=42d78beb&scoped=true"
import script from "./NewsBanner.vue?vue&type=script&lang=js"
export * from "./NewsBanner.vue?vue&type=script&lang=js"

import "./NewsBanner.vue?vue&type=style&index=0&id=42d78beb&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42d78beb"]])

export default __exports__